import { Fragment, useState } from 'react';
import { Button } from '@shared/ui/Button';
import { Input } from '@shared/ui/Input';
import { useSetKadryVacancyMutation } from '@shared/api';
import type { KadryVacancyLink } from '@entities/kadry';
import { KadryMuted, KadryErrorBanner } from '../../ui';
import { VacancyRow } from './styles';
import { VACANCY_UI } from './types';

/** Вакансия площадки заявки: на неё уходят приглашения кандидатам с этой площадки. */
export function VacancyEditor({
  requestId,
  source,
  link,
  canEdit,
}: {
  requestId: string;
  source: 'hh' | 'rabota';
  link?: KadryVacancyLink;
  canEdit: boolean;
}) {
  const ui = VACANCY_UI[source];
  const [setVacancy, state] = useSetKadryVacancyMutation();
  const [draft, setDraft] = useState('');
  const [edit, setEdit] = useState(false);
  return (
    <>
      <VacancyRow
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            await setVacancy({ requestId, source, vacancy: draft }).unwrap();
            setEdit(false);
          } catch {
            /* ошибка показана ниже */
          }
        }}
      >
        <span>Вакансия на {ui.title}:</span>
        {/* Разные key у режимов: иначе React переиспользует кнопку «Изменить»
            под «Сохранить» (type=submit) прямо во время клика, и браузер
            отправляет форму со старой ссылкой — правка «не срабатывает». */}
        {link && !edit ? (
          <Fragment key="view">
            <a href={link.url} target="_blank" rel="noreferrer">
              № {link.ext_vacancy_id}
            </a>
            {canEdit && (
              <Button
                type="button"
                $size="sm"
                $variant="ghost"
                onClick={(e) => {
                  e.preventDefault();
                  setDraft(link.url);
                  setEdit(true);
                }}
              >
                Изменить
              </Button>
            )}
          </Fragment>
        ) : canEdit ? (
          <Fragment key="edit">
            <Input
              value={draft}
              placeholder={ui.placeholder}
              onChange={(e) => setDraft(e.target.value)}
              aria-label={`Ссылка на вакансию ${ui.title}`}
            />
            <Button type="submit" $size="sm" disabled={!draft.trim() || state.isLoading}>
              Сохранить
            </Button>
            {link && (
              <Button type="button" $size="sm" $variant="ghost" onClick={() => setEdit(false)}>
                Отмена
              </Button>
            )}
          </Fragment>
        ) : (
          <KadryMuted as="span">не указана</KadryMuted>
        )}
      </VacancyRow>
      {state.error ? <KadryErrorBanner error={state.error} onDismiss={() => state.reset()} /> : null}
    </>
  );
}
